import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import { EstadosBajaActivoConstant } from 'constants/index'

import * as ActivosFijosBajasService from 'services/activosFijosBajas.service'

import { ZrSwal } from 'utils'

const portletBreadcrumbs = [{ name: 'Activos Fijos' }, { name: 'Bajas' }]

const tableHeaderRows = [
  { label: 'CODIGO', filter: { type: 'text', name: 'codigo' } },
  { label: 'ACTIVO FIJO', filter: { type: 'text', name: 'codigoActivoFijo' } },
  { label: 'DESCRIPCIÓN' },
  { label: 'SOLICITANTE' },
  { label: 'FEC SOLICITUD' },
  { label: 'FEC BAJA' },
  { label: 'VALOR LIBROS' },
  { label: 'ESTADO' },
  { label: '', width: 60 }
]

const ListaPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)
  const tablaRef = React.useRef(null)

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_BAJAS_NUEVO}`)
  }, [history])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_BAJAS_EDITAR}/${_id}`)
    },
    [history]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      ZrSwal.showAlert({
        mensaje: '¿Seguro que desea eliminar la baja?',
        tipo: 'error',
        onSuccess: () => {
          ActivosFijosBajasService.eliminar(_id)
            .then(() => {
              __zariContext.snack('success', 'Registro eliminado!')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header
        title='Bajas de Activos Fijos'
        breadcrumbs={portletBreadcrumbs}
        buttons={[{ name: 'Nueva Baja', onClick: clickNuevo }]}
      />
      <Portlet.Body>
        <Table.ServerSide
          useNest={true}
          ref={tablaRef}
          useFilters={true}
          url='/activos-fijos-bajas'
          headRows={tableHeaderRows}
          rowTemplate={row => (
            <Table.Row key={row._id}>
              <Table.Cell>{row.codigo || '--'}</Table.Cell>
              <Table.Cell>{row.codigoActivoFijo || '--'}</Table.Cell>
              <Table.Cell>{row.descripcionActivoFijo || '--'}</Table.Cell>
              <Table.Cell>{row.solicitanteNombre || '--'}</Table.Cell>
              <Table.Cell>{row.fechaSolicitud || '--'}</Table.Cell>
              <Table.Cell>{row.fechaBaja || '--'}</Table.Cell>
              <Table.Cell>{row.valorEnLibros != null ? Number(row.valorEnLibros).toFixed(2) : '--'}</Table.Cell>
              <Table.Cell>
                {row.estado && EstadosBajaActivoConstant.__dictionary[row.estado]
                  ? EstadosBajaActivoConstant.__dictionary[row.estado].nombre
                  : '--'}
              </Table.Cell>
              <Table.Cell>
                <Table.Dropdown>
                  {({ handleClose }) => [
                    <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                      Ver / Editar
                    </Table.Dropdown.Item>,
                    <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                      Eliminar
                    </Table.Dropdown.Item>
                  ]}
                </Table.Dropdown>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ListaPage)
